import React, { Fragment } from 'react';
import styled from 'styled-components';
import Tooltip from 'rc-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'i18n';
import servicesIconsMap from 'routes/checkoutPage/constants/servicesIconsMap';
import Summary from 'routes/checkoutPage/components/travelSummary/components/summarySection/SummarySection';
import FlightDetailsModal from 'routes/checkoutPage/steps//flights/components/flightCombinationsList/components/flightCombinationsCard/components/flightDetailsModal/FlightDetailsModal';
import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';
import OvernightIcon from 'components/dataPresentation/OvernightIcon/OvernightIcon';

function FlightsSummaryComponent({
  summaryKey,
  searchToken,
  productToken,
  flights,
  modalOpen,
  onClickFlightDetails,
  onClickCloseFlightDetailsModal,
}) {
  const title = <FormattedMessage id={'flights.label'} description={'Flights'} defaultMessage={'Flights'} />;
  return (
    <Fragment>
      <Summary summaryKey={summaryKey} title={title}>
        <Root>
          {flights.map(
            (
              {
                departureTime,
                departureDate,
                departureAirport,
                departureAirportName,
                destinationAirport,
                destinationAirportName,
                carriers,
                flightNumber,
                isOvernight,
              },
              index
            ) => (
              <FlightWrap key={`summary-flights-${index}`}>
                <Icon>
                  <FontAwesomeIcon
                    icon={index === 0 ? servicesIconsMap.PlaneDeparture : servicesIconsMap.PlaneArrival}
                  />
                </Icon>
                <Data>
                  <DateTimeWrap>
                    <Date>{departureTime}</Date>
                    <VerticalSeparator />
                    <Time>{departureDate}</Time>
                  </DateTimeWrap>
                  <Airports>
                    <Tooltip placement='top' trigger={['hover']} overlay={departureAirportName} destroyTooltipOnHide>
                      <Airport>{departureAirport}</Airport>
                    </Tooltip>
                    &nbsp;&nbsp;-&nbsp;&nbsp;
                    <Tooltip placement='top' trigger={['hover']} overlay={destinationAirportName} destroyTooltipOnHide>
                      <Airport>{destinationAirport}</Airport>
                    </Tooltip>
                    &nbsp;
                    <OvernightIcon isOvernight={isOvernight}/>
                  </Airports>
                  <CarrierAndFlightNumber>
                    {carriers[0].carrierName}&nbsp;{carriers[0].carrierCode}&nbsp;{flightNumber}
                  </CarrierAndFlightNumber>
                </Data>
              </FlightWrap>
            )
          )}
          <ViewDetails onClick={onClickFlightDetails}>
            <FormattedMessage
              id={'viewFullFlightDetails.label'}
              description={'View full flight details'}
              defaultMessage={'View full flight details'}
            />
          </ViewDetails>
        </Root>
      </Summary>
      <FlightDetailsModal
        searchToken={searchToken}
        productToken={productToken}
        resetDataOnClose
        modalOpen={modalOpen}
        onClickClose={onClickCloseFlightDetailsModal}
      />
    </Fragment>
  );
}

export default FlightsSummaryComponent;

const Root = styled.div`
  > * {
    margin-bottom: 20px;
  }
`;

const FlightWrap = styled.div`
  ${flexbox()}
`;

const Icon = styled.div`
  margin-right: 7px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.light};
`;

const Data = styled.div`
  > *:not(:last-child) {
    margin-bottom: 12px;
  }
`;

const DateTimeWrap = styled.div`
  ${flexbox()}
  font-size: 1.6em;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.default};

  ${mediaQueries.fromAndAbove.desktop`
    font-size: 1.3em;
  `}
`;

const Date = styled.div``;

const Time = styled.div``;

const VerticalSeparator = styled.div`
  height: 12px;
  width: 1px;
  background: ${({ theme }) => theme.colors.primary.default};
  margin: 0 8px;
`;

const Airports = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.4em;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.default};

  ${mediaQueries.fromAndAbove.desktop`
    font-size: 1.2em;
  `}
`;

const Airport = styled.span`
  border-bottom: 1px dashed #999999;
`;

const CarrierAndFlightNumber = styled.div`
  font-size: 1.4em;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.default};

  ${mediaQueries.fromAndAbove.desktop`
    font-size: 1.2em;
  `}
`;

const ViewDetails = styled.button`
  width: 100%;
  padding: 16px;
  background: none;
  border: 1px solid ${({ theme }) => theme.colors.links.default};
  border-radius: 10px;
  font-size: 1.8em;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  color: ${({ theme }) => theme.colors.links.default};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  ${mediaQueries.fromAndAbove.desktop`
    padding: initial;
    background: none;
    border: none;
    border-radius: 0;
    font-size: 1.3em;
  `}
`;
